export default __webpack_public_path__ + "static/media/delete-members-icon.aa8d8751.svg";